import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../../hooks/useTheme';

const MobileDynamicBanner = ({
	Title,
	SubtitleOne: Description,
	SubtitleTwo: TextLink,
	AltText = '',
	linkUrl,
	ImageUrl,
	openTextLinkInNewTab,
}) => {
	const { background, title, description, link } = useTheme('middleBanner');
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	return (
		<div
			data-testid="dynamic-banner"
			className={classnames(
				'flex flex-col items-center text-center border border-solid border-gray-30 p-4',
				background,
				{
					'rounded m-2': CustomCategoriesEnabled,
					'rounded-lg mx-2 sm:mx-1 mb-2 sm:mb-1 sm:mt-1 w-full ': !CustomCategoriesEnabled,
				}
			)}>
			<div className={`text-title-lg pb-2 ${title}`}>{Title}</div>
			<div className={`text-body-sm pb-2 ${description}`}>{Description}</div>

			{linkUrl ? (
				<a
					data-testid="text-link"
					className={`text-body-sm font-bold ${link}`}
					href={linkUrl}
					onClick={openTextLinkInNewTab}>
					{TextLink}
				</a>
			) : (
				<span className={`text-body-sm ${link}`}>{TextLink}</span>
			)}

			{ImageUrl && (
				<div className="flex pt-2">
					{linkUrl ? (
						<a
							data-testid="image-link"
							className="mx-auto font-bold"
							href={linkUrl}
							onClick={openTextLinkInNewTab}>
							<img style={{ height: '100px' }} alt={AltText} src={ImageUrl} />
						</a>
					) : (
						<img style={{ height: '100px' }} alt={AltText} src={ImageUrl} />
					)}
				</div>
			)}
		</div>
	);
};

export default MobileDynamicBanner;
